import React, {useEffect} from 'react';
import {jsPDF} from 'jspdf';
import autoTable from 'jspdf-autotable';
import addFont from '../../../assets/fonts/fonts';

const orientation = 'l';

const ITEMS = ['Основные мероприятия', 'Дополнительные мероприятия', 'Внедрение новых технологий'];

const ScholarshipTable = ({
    name,
    gou,
    year,
    meth_plan_1,
    meth_plan_2,
    meth_plan_3,
    meth_plan_4,
    setFile,
    file,
    setIsPopup
}) => {

    const getData = (data) => {
        const x = Object.values(data)?.map((el, i) => {
            const val = el?.[i + 1];
            const data1 = [[val?.[0], val?.[1]]];

            const data2 = val.slice(2).map((el) => {
                return [
                    el?.code || '-',
                    el?.title || '-',
                    `${el?.from_date || '-'} - ${el?.to_date || '-'}`,
                    el?.members || '-',
                    el?.responsibles || '-',
                    el?.isDone === 1 ? 'Да' : 'Нет'
                ];
            });
            return [data1, data2];
        });
        return x;
    };

    console.log(meth_plan_1);
    console.log(meth_plan_2);
    console.log(meth_plan_3);

    const generatePDF = async (tables) => {
        addFont(jsPDF.API);
        let currentY = 10;
        const maxWidth = 270;
        const doc = new jsPDF({orientation});
        const pageHeight = doc.internal.pageSize.height;
        const usableHeight = pageHeight - 10 * 2;
        let pageCount = 1;
        doc.setFont('TimesNewRoman');
        doc.setFontSize(14);

        const transformData = (data) => {
            const result = [];

            Object.keys(data).forEach((key) => {
                const match = key.match(/goal(\d+)_(name|desc)/);
                if (match) {
                    const [_, number, type] = match;
                    const index = parseInt(number, 10) - 1;

                    if (!result[index]) {
                        result[index] = {name: '', desc: ''};
                    }

                    result[index][type] = data[key];
                }
            });

            return result;
        };

        const titles = {
            0: '3. СОДЕРЖАНИЕ МЕТОДИЧЕСКОЙ ДЕЯТЕЛЬНОСТИ',
            1: '4. ТЕХНОЛОГИИ И НОВОВВЕДЕНИЯ',
            2: '5. ДОПОЛНЕНИЯ',
            3: '6. ИЗМЕНЕНИЯ И ДОПОЛНЕНИЯ',
        };

        const getInfo = () => {
            doc.setFontSize(10);
            doc.setFont('TimesNewRoman');
            doc.text(`Кто создал: ${name}`, 20, 195, {maxWidth: 300, align: 'left'});
            doc.text(`Когда создал: ${new Date().toLocaleString()}`, 150, 195, {maxWidth: 300, align: 'left'});
            doc.text(`Лист: ${pageCount}`, 280, 195, {maxWidth: 300, align: 'right'});
            pageCount++;
        };

        doc.setFontSize(15);
        doc.text(gou, 150, currentY + 3, {
            maxWidth: 300,
            align: 'center'
        });

        doc.setFontSize(25);
        doc.setFont('TimesNewRomanBold');
        doc.text('ПЛАН', 150, 100, {
            maxWidth: 300,
            align: 'center'
        });

        doc.setFontSize(16);
        doc.text(`методической деятельности образовательной организации на ${year} учебный год`, 150, 110, {
            maxWidth: 300,
            align: 'center'
        });

        getInfo();
        doc.addPage();

        doc.setFontSize(14);
        doc.setFont('TimesNewRomanBold');
        doc.text('1. ОСНОВНЫЕ ЦЕЛИ И ЗАДАЧИ МЕТОДИЧЕСКОЙ ДЕЯТЕЛЬНОСТИ', 150, currentY + 3, {
            maxWidth: 300,
            align: 'center'
        });
        currentY += 12;

        transformData(tables[0]).map((element) => {
            let lines = null;
            if (currentY > 150) {
                currentY = 15;
                getInfo();
                doc.addPage();
            }

            doc.setFontSize(12);
            doc.setFont('TimesNewRomanBold');
            doc.text(element?.name, 16, currentY, {
                maxWidth: 270,
                align: 'left'
            });
            lines = doc.splitTextToSize(element.name, maxWidth);
            currentY = currentY + 0 + (doc.getTextDimensions(element.name).h * lines.length);

            doc.setFontSize(12);
            doc.setFont('TimesNewRoman');
            doc.text(element?.desc || '-', 15, currentY + 2, {
                maxWidth: 270,
                align: 'left'
            });
            lines = doc.splitTextToSize(element.desc, maxWidth);
            currentY = currentY + 20 + (doc.getTextDimensions(element.desc || '-').h * lines.length);
        });

        getInfo();
        doc.addPage();
        currentY = 10;
        doc.setFontSize(14);
        doc.setFont('TimesNewRomanBold');
        doc.text('2. ОРГАНИЗАЦИОННО-МЕТОДИЧЕСКИЕ УКАЗАНИЯ', 150, currentY + 3, {
            maxWidth: 300,
            align: 'center'
        });

        currentY = currentY + 12;
        doc.setFontSize(12);
        doc.setFont('TimesNewRoman');

        const lines = doc.splitTextToSize(meth_plan_2?.ukaz || '-', maxWidth);

        lines.map(line => {
            if (currentY + 10 > usableHeight) {
                getInfo();
                doc.addPage();
                currentY = 10;
            }
            doc.setFontSize(12);
            doc.text(line || '-', 20, currentY + 3, {
                maxWidth: 270,
                align: 'left'
            });
            currentY += 5;
        });

        const tableColumnWidths = {
            0: {cellWidth: 0.10 * doc.internal.pageSize.width, halign: 'center'},
            1: {cellWidth: 0.15 * doc.internal.pageSize.width, halign: 'center'},
            2: {cellWidth: 0.15 * doc.internal.pageSize.width, halign: 'center'},
            3: {cellWidth: 0.20 * doc.internal.pageSize.width, halign: 'center'},
            4: {cellWidth: 0.20 * doc.internal.pageSize.width - 14, halign: 'center'},
            5: {cellWidth: 0.20 * doc.internal.pageSize.width - 14, halign: 'center'},
        };
        const tableColumnWidths2 = {
            0: {cellWidth: 'wrap', cellHeight: '16', halign: 'center'},
        };

        const headers = ['Номер\n п.п.', 'Мероприятие', 'Срок выполнения', 'Ответсвтенные за выполнение', 'Участники', 'Отметка о выполнении'];

        getInfo();
        ITEMS.forEach((title, index) => {
            const data = meth_plan_3[title];

            currentY = 10;
            doc.addPage();
            getInfo();

            doc.setFontSize(14);
            doc.setFont('TimesNewRomanBold');
            doc.text(titles[index], 150, currentY + 3, {
                maxWidth: 300,
                align: 'center'
            });

            Object.values(data).forEach(i => {
                const item = getData([{1: i}]);
                currentY = currentY + 12;

                autoTable(doc, {
                    head: null,
                    body: [headers],
                    startY: currentY,
                    columnStyles: tableColumnWidths,
                    styles: {
                        cellWidth: 'wrap',
                        font: 'TimesNewRomanBold',
                        fontSize: 10,
                        cellPadding: 2,
                        halign: 'center',
                        valign: 'middle',
                        lineWidth: 0.1,
                        lineColor: [0, 0, 0],
                    },
                    headStyles: {
                        cellWidth: 'wrap',
                        fillColor: [255, 255, 255],
                        textColor: [0, 0, 0],
                        fontStyle: 'bold',
                    },
                    alternateRowStyles: {
                        fillColor: [255, 255, 255],
                    },
                    tableLineColor: [0, 0, 0],
                    bodyStyles: {
                        textColor: [0, 0, 0],
                    },
                    tableLineWidth: 0.1,
                });

                currentY = doc.lastAutoTable.finalY;

                const xx = item[0][0][0];

                xx.forEach((el, i) => {
                    if (i > 0) {
                        currentY += 5;
                        if (currentY > pageHeight - 30) {
                            getInfo();
                            doc.addPage();
                            currentY = 10;
                        }
                    }

                    autoTable(doc, {
                        head: null,
                        body: item[0] == 'Нет данных' ? ['Нет данных'] : [[el]],
                        startY: currentY,
                        columnStyles: tableColumnWidths2,
                        styles: {
                            cellWidth: 'wrap',
                            font: 'TimesNewRomanBold',
                            fontSize: 10,
                            cellPadding: 2,
                            halign: 'center',
                            valign: 'middle',
                            lineWidth: 0.1,
                            lineColor: [0, 0, 0],
                        },
                        headStyles: {
                            cellWidth: 'wrap',
                            fillColor: [255, 255, 255],
                            textColor: [0, 0, 0],
                            fontStyle: 'bold',
                        },
                        alternateRowStyles: {
                            fillColor: [255, 255, 255],
                        },
                        tableLineColor: [0, 0, 0],
                        bodyStyles: {
                            textColor: [0, 0, 0],
                        },
                        tableLineWidth: 0.1,
                    });
                    currentY = doc.lastAutoTable.finalY;
                });

                if (item[0][0][0] !== 'Нет данных') {
                    item[0][1].forEach((el_, i_) => {
                        if (i_ > 0 && currentY + 10 > pageHeight - 30) {
                            getInfo();
                            doc.addPage();
                            currentY = 10;
                        }

                        autoTable(doc, {
                            head: null,
                            body: [el_],
                            startY: currentY,
                            columnStyles: tableColumnWidths,
                            styles: {
                                cellWidth: 'wrap',
                                font: 'TimesNewRoman',
                                fontSize: 10,
                                cellPadding: 2,
                                halign: 'center',
                                valign: 'middle',
                                lineWidth: 0.1,
                                lineColor: [0, 0, 0],
                            },
                            headStyles: {
                                cellWidth: 'wrap',
                                fillColor: [255, 255, 255],
                                textColor: [0, 0, 0],
                                fontStyle: 'bold',
                            },
                            alternateRowStyles: {
                                fillColor: [255, 255, 255],
                            },
                            tableLineColor: [0, 0, 0],
                            bodyStyles: {
                                textColor: [0, 0, 0],
                            },
                            tableLineWidth: 0.1,
                        });
                        currentY = doc.lastAutoTable.finalY;
                    });
                }

                if (index === 1) {
                    currentY += 10;

                    if (currentY > pageHeight - 30) {
                        getInfo();
                        doc.addPage();
                        currentY = 10;
                    }

                    doc.setFontSize(12);
                    doc.setFont('TimesNewRoman');
                    doc.text('Сокращения и условные обозначения используемые при заполнении плана', 15, currentY, {
                        maxWidth: 270,
                        align: 'left'
                    });
                }
            });
        });

        doc.addPage();
        currentY = 10;
        doc.setFont('TimesNewRomanBold');

        doc.text('6. ИЗМЕНЕНИЯ И ДОПОЛНЕНИЯ', 150, currentY + 3, {
            maxWidth: 300,
            align: 'center'
        });

        if (meth_plan_4?.length) {
            autoTable(doc, {
                head: [
                    [
                        {content: 'Номер изменения', rowSpan: 2},
                        {content: 'Изменяемый пункт', rowSpan: 2},
                        {content: 'Содержание изменения', colSpan: 2},
                        {content: 'Документ на основании которого внесено изменение', rowSpan: 2},
                    ],
                    [
                        'Исходная формулировка',
                        'Следует читать',
                    ],
                ],
                body: meth_plan_4.map((item) => [
                    item.change_number,
                    item.punkt,
                    item.after,
                    item.before,
                    item.doc,
                ]),
                startY: currentY + 10,
                styles: {
                    font: 'TimesNewRoman',
                    fontSize: 10,
                    cellPadding: 2,
                    halign: 'center',
                    valign: 'middle',
                    lineWidth: 0.1,
                    lineColor: [0, 0, 0],
                },
                headStyles: {
                    font: 'TimesNewRomanBold',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontStyle: 'bold',
                },
                alternateRowStyles: {
                    fillColor: [255, 255, 255],
                },
                tableLineColor: [0, 0, 0],
                bodyStyles: {
                    textColor: [0, 0, 0],
                },
                tableLineWidth: 0.1,
            });
        }

        setFile(doc.output('blob'));
    };

    const handleGeneratePDF = () => {
        generatePDF(meth_plan_1);
    };

    useEffect(() => {
        if (meth_plan_1 !== null) {
            handleGeneratePDF();
        }
    }, [meth_plan_1, meth_plan_4]);

    return <></>;
};

export default ScholarshipTable;
